import { usePlanningStore } from '@planning/AppProvider'
import { useTranslate } from '@tolgee/react'
import { OptionsButton } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { FC, useState } from 'react'
import { RailcarPlanningViewStore } from '../../Stores/RailcarPlanningViewStore'
import { RailcarPlanningChangeRailtrackDialog } from '../Dialogs/RailcarPlanningChangeRailtrackDialog'
import { RailcarPlanningChangeSequenceNumberDialog } from '../Dialogs/RailcarPlanningChangeSequenceNumberDialog'
import { RailcarPlanningRailcarProps } from './RailcarPlanningRailcar'

type Props = {
  railcarPlanningViewStore: RailcarPlanningViewStore
  railcar: RailcarPlanningRailcarProps
}

export const RailcarPlanningRailcarMenu: FC<Props> = observer(props => {
  const { t } = useTranslate()
  const { appViewStore } = usePlanningStore()

  const { railcarPlanningViewStore, railcar } = props

  const [dialogMode, setDialogMode] = useState<'sequence' | 'railtrack' | null>(null)

  return (
    <>
      <OptionsButton
        options={[
          {
            label: t('changeSequenceNo', 'Change sequence no.'),
            onClick: () => {
              setDialogMode('sequence')
            },
          },
          {
            label: t('changeRailtrack', 'Change rail track'),
            onClick: () => {
              setDialogMode('railtrack')
            },
          },
          {
            label: t('delete', 'Delete'),
            onClick: async () => {
              const confirmation = await appViewStore.setOpenConfirmDialog(
                true,
                t(
                  'railcarDeleteConfirmation',
                  'All containers assigned to {railcar} will be unassigned and returned to the container list. They will need to be reassigned later. Are you sure you want to delete this railcar?',
                  { railcar: railcar.number },
                ),
                t('deleteRailcar', 'Delete {railcar}?', { railcar: railcar.number }),
                undefined,
                {
                  maxWidth: 'sm',
                  primaryActionText: t('yesDelete', 'Yes, delete'),
                  secondaryActionText: t('noBackToTrackAssignment', 'No, back to track assignment'),
                },
              )

              if (confirmation) {
                railcarPlanningViewStore.deleteRailcar(
                  railcar.railcarTrackPositionId,
                  railcarPlanningViewStore.railVisitItem.id,
                )
              }
            },
          },
        ]}
        position='right'
      />

      {dialogMode === 'sequence' && (
        <RailcarPlanningChangeSequenceNumberDialog
          railcarPlanningViewStore={railcarPlanningViewStore}
          railVisitId={railcarPlanningViewStore.railVisitItem.id}
          railTrackId={railcar.railTrackId}
          railcarTrackPositionId={railcar.railcarTrackPositionId}
          open={dialogMode === 'sequence'}
          onClose={() => setDialogMode(null)}
        />
      )}
      {dialogMode === 'railtrack' && (
        <RailcarPlanningChangeRailtrackDialog
          railcarPlanningViewStore={railcarPlanningViewStore}
          railVisitId={railcarPlanningViewStore.railVisitItem.id}
          railcarTrackPositionId={railcar.railcarTrackPositionId}
          open={dialogMode === 'railtrack'}
          onClose={() => setDialogMode(null)}
        />
      )}
    </>
  )
})
